import { BaseApi } from '@smorder/logic';

class OrderApi extends BaseApi {
  * loadOrders() {
    return yield this.authorizedFetch('/api/v1/orders', {
      method: 'GET',
    });
  }

  * loadOrder(orderId) {
    return yield this.authorizedFetch(`/api/v1/orders/${orderId}`, {
      method: 'GET',
    });
  }

  * proceedOrder(orderId) {
    return yield this.authorizedFetch(`/api/v1/order/${orderId}/state`, {
      method: 'POST',
    });
  }

  * declineOrder(orderId) {
    return yield this.authorizedFetch(`/api/v1/order/${orderId}`, {
      method: 'DELETE',
    });
  }
}

export default OrderApi;
